// extracted by mini-css-extract-plugin
export default {"header-title_reverse":"pW7VP"};